import React, { useEffect, useMemo, useState } from "react";
import close from "../../../assets/images/close.svg";
import {
    Button,
    Col,
    Container,
    Form,
    Modal,
    Nav,
    Row,
    Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import WebhookCommon from "../../common-component/WebhookCommon";
import addicon from "../../../assets/images/addicon.svg";
import removeicon from "../../../assets/images/deleteaction.svg";
import { default as infoIcon } from "../../../assets/images/infobtnblue.svg";
import CustomSelect from "../../ConfigurationComponent/CustomSelect";

import { useDispatch, useSelector } from "react-redux";
import { ProjectTermGetList } from "../../../services/ReduxTookit/Slice/ProjectTermRedux";
import { EKSNodeGroupService } from "../../../services/EKSNodeGroupService";
import { GetBySubscriber } from "../../../services/ReduxTookit/Slice/SubscribersInfrastructureAutomation";

function ConfigModel({
    workspaceList,
    handleshowPopup,
    isViewMode,
    associationid,
    associationtype,
    workflowdata,
    configurationsave,
    viewOption
}) {

    const dispatch = useDispatch();

    const [ProjectTermList, setProjectTermList] = useState([]);
    const [EksNodeList, setEksNodeList] = useState([]);
    const [infraAutomationList, setInfraAutomationList] = useState([]);
    const [infraLoading, setInfraLoading] = useState(false);

    const parameterKeyRegex = /^[A-Za-z0-9_]+$/;
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    const decimalRegex = /^-?\d+(\.\d+)?$/;
    const numberRegex = /^-?\d+$/;

    const [workspaceListOpt, setWorkspaceListOpt] = useState(workspaceList);
    const [workspaceInput, setWorkspaceInput] = useState(
        workflowdata.workspaceInput,
    );
    const [eksLoading, setEksLoading] = useState(false);

    const [configInput, setConfigInput] = useState({
        parallelism: 2,
        retrystrategy: 3,
        parametersforworkflow: [],
        workspaceInput: [],
        eksnodegroup: "",
        subscribersinfrastructureautomationid: "",
    });

    const fnInputChange = (value, tag) => {
        if (tag === "subscribersinfrastructureautomationid") {
            setConfigInput({
                ...configInput,
                subscribersinfrastructureautomationid: value,
                eksnodegroup: value ? "" : configInput.eksnodegroup,
            });
        } else if (tag === "eksnodegroup") {
            setConfigInput({
                ...configInput,
                eksnodegroup: value,
                subscribersinfrastructureautomationid: value ? "" : configInput.subscribersinfrastructureautomationid,
            });
        } else {
            setConfigInput({
                ...configInput,
                [tag]: value,
            });
        }
    };

    async function getProjectTermList() {
        dispatch(ProjectTermGetList({ category: "Input Type" }))?.then((response) => {
            if (response?.payload?.isValidate) {
                if (response?.payload?.data?.data?.length > 0) {
                    setProjectTermList(response?.payload?.data?.data.filter(
                        (f) => f.category === "Input Type"
                    ));
                }
            }
            if (!response?.payload?.isValidate) {
            }
        });
    }

    async function getEksNodeList() {
        setEksLoading(true);
        const response = await EKSNodeGroupService.getList();
        const payload = response?.data ?? response;
        const list = payload?.data ?? payload?.DataList1 ?? payload?.dataList1 ?? [];
        const items = Array.isArray(list) ? list : [];
        setEksNodeList(items.map((item) => ({ key: item.nodegroup_name, value: item.instancedisplayname })));
        setEksLoading(false);
    }

    async function getInfraAutomationList() {
        setInfraLoading(true);
        dispatch(GetBySubscriber({ status: "Completed" }))?.then((response) => {
            setInfraLoading(false);
            if (response?.payload?.isValidate) {
                const data = response?.payload?.data?.data;
                if (Array.isArray(data)) {
                    setInfraAutomationList(data);
                } else if (data && typeof data === "object") {
                    setInfraAutomationList([data]);
                } else {
                    setInfraAutomationList([]);
                }
            } else {
                setInfraAutomationList([]);
            }
        }).catch(() => {
            setInfraLoading(false);
            setInfraAutomationList([]);
        });
    }

    useEffect(() => {
        if (!workflowdata) return;
        const normalizedParameters = (workflowdata.parametersforworkflow || []).map(
            (item) => ({
                ...item,
                inputType: item.inputType || "Text Box",
                isvalidType: item.isvalidType || "",
            }),
        );
        setConfigInput({
            ...workflowdata,
            subscribersinfrastructureautomationid: workflowdata.subscribersinfrastructureautomationid || "",
            parametersforworkflow: normalizedParameters,
        });
    }, [workflowdata]);

    const inputTypeOptions = useMemo(() => {
        if (!ProjectTermList || ProjectTermList.length === 0) return [];
        return ProjectTermList.filter(
            (item) =>
                item?.term &&
                item.term !== "Dropdown Single Select" &&
                item.term !== "Dropdown Multiple Select" &&
                item.term !== "File",
        ).map((item) => ({
            value: item.term,
            label: item.term,
        }));
    }, [ProjectTermList]);

    const getValueValidationMessage = (value, inputType) => {
        const currentValue = value ?? "";
        const currentType = inputType || "Text Box";

        if (currentValue === "" && currentValue !== 0) {
            return "Value is required";
        }

        switch (currentType) {
            case "Date Picker":
                return /^\d{4}-\d{2}-\d{2}$/.test(String(currentValue))
                    ? ""
                    : "Enter a valid date";
            case "Time Picker":
                return timeRegex.test(String(currentValue))
                    ? ""
                    : "Enter a valid time (HH:mm)";
            case "Date Time Picker":
                return !Number.isNaN(new Date(currentValue).getTime())
                    ? ""
                    : "Enter a valid date and time";
            case "Json":
                try {
                    JSON.parse(String(currentValue));
                    return "";
                } catch (error) {
                    return "Enter a valid JSON value";
                }
            case "Decimal":
                return decimalRegex.test(String(currentValue))
                    ? ""
                    : "Enter a valid decimal number";
            case "Number":
                return numberRegex.test(String(currentValue))
                    ? ""
                    : "Enter a valid whole number";
            default:
                return "";
        }
    };

    const getInputControlByType = (inputType) => {
        switch (inputType) {
            case "Text Area":
                return { as: "textarea", rows: 3, type: undefined, placeholder: "Enter value" };
            case "Password":
                return { as: undefined, rows: undefined, type: "password", placeholder: "Enter value" };
            case "Date Picker":
                return { as: undefined, rows: undefined, type: "date", placeholder: "" };
            case "Time Picker":
                return { as: undefined, rows: undefined, type: "time", placeholder: "" };
            case "Date Time Picker":
                return { as: undefined, rows: undefined, type: "datetime-local", placeholder: "" };
            case "Decimal":
                return { as: undefined, rows: undefined, type: "number", step: "any", placeholder: "Enter value" };
            case "Number":
                return { as: undefined, rows: undefined, type: "number", step: "1", placeholder: "Enter value" };
            default:
                return { as: undefined, rows: undefined, type: "text", placeholder: "Enter value" };
        }
    };

    useEffect(() => {
        getProjectTermList();
        getEksNodeList();
        getInfraAutomationList();
    }, []);

    const handleSaveConfig = (e) => {
        let _configInput = { ...configInput };
        if (
            _configInput.parametersforworkflow &&
            _configInput.parametersforworkflow.length > 0
        ) {
            if (_configInput.parametersforworkflow[0].value === "") {
                _configInput.parametersforworkflow = [];
            }
        }

        // Workspace
        if (workspaceInput.length > 0) {
            _configInput.workspaceInput = workspaceInput;
        } else {
            _configInput.workspaceInput = [];
            return;
        }
        configurationsave(_configInput);
    };

    const handleSavePara = (e) => {
        let _configInput = { ...configInput };
        let isValidData = true;
        const nameCountMap = {};
        nameCountMap["loops".toUpperCase()] = 1;

        _configInput.parametersforworkflow.forEach((item) => {
            const paraName = (item.name || "").trim();
            if (paraName) {
                nameCountMap[paraName.toUpperCase()] = (nameCountMap[paraName.toUpperCase()] || 0) + 1;
            }
        });

        for (let i = 0; i < _configInput.parametersforworkflow.length; i++) {
            const paraName = (_configInput.parametersforworkflow[i].name || "").trim();
            const paraValue = _configInput.parametersforworkflow[i].value;
            const paraInputType = _configInput.parametersforworkflow[i].inputType || "Text Box";

            if (!paraName) {
                isValidData = false;
                _configInput.parametersforworkflow[i].isvalidName =
                    "Key name is required";
            } else if (!parameterKeyRegex.test(paraName)) {
                isValidData = false;
                _configInput.parametersforworkflow[i].isvalidName =
                    "Only letters, numbers and _ are allowed";
            } else if (nameCountMap[paraName.toUpperCase()] > 1) {
                isValidData = false;
                _configInput.parametersforworkflow[i].isvalidName =
                    "Loops and Duplicate key name is not allowed";
            } else {
                _configInput.parametersforworkflow[i].isvalidName = "";
            }

            if (!paraInputType) {
                isValidData = false;
                _configInput.parametersforworkflow[i].isvalidType = "Input type is required";
            } else {
                _configInput.parametersforworkflow[i].isvalidType = "";
            }

            const valueValidationMessage = getValueValidationMessage(paraValue, paraInputType);
            if (!valueValidationMessage) {
                _configInput.parametersforworkflow[i].isvalid = "";
            } else {
                isValidData = false;
                _configInput.parametersforworkflow[i].isvalid = valueValidationMessage;
            }
        }

        if (isValidData) {
            configurationsave(_configInput);
        } else {

            setConfigInput(_configInput);
        }
    };

    function fnChangeParaName(value, index) {
        let _configInput = { ...configInput };
        if (index > -1) {
            const normalizedKey = value.replace(/[^A-Za-z0-9_]/g, "");
            configInput.parametersforworkflow[index].name = normalizedKey;
            configInput.parametersforworkflow[index].isvalidName = "";
        }

        setConfigInput(_configInput);
    }

    function fnChangeParaValue(value, index) {
        let _configInput = { ...configInput };
        if (index > -1) {
            configInput.parametersforworkflow[index].value = value;
            configInput.parametersforworkflow[index].isvalid = "";
        }

        setConfigInput(_configInput);
    }

    function fnChangeParaInputType(value, index) {
        let _configInput = { ...configInput };
        if (index > -1) {
            configInput.parametersforworkflow[index].inputType = value;
            configInput.parametersforworkflow[index].isvalidType = "";
            configInput.parametersforworkflow[index].isvalid = "";
            configInput.parametersforworkflow[index].value = "";
        }

        setConfigInput(_configInput);
    }

    function fnAddPara() {
        let _configInput = { ...configInput };
        configInput.parametersforworkflow.push({
            name: "",
            inputType: "Text Box",
            value: "",
            isvalid: "",
            isvalidName: "",
            isvalidType: "",
        });

        setConfigInput(_configInput);
    }

    function fnRemovePara(index) {
        let _configInput = { ...configInput };
        if (index > -1) {
            configInput.parametersforworkflow.splice(index, 1);
        }

        setConfigInput(_configInput);
    }

    return (
        <>
            <div
                className="schedular-popup configmain-section"
                style={{ color: "black" }}
            >
                <div className="popup-title">
                    <h2>Workflow Configuration</h2>
                    <img
                        src={close}
                        alt="close"
                        className="cursor-pointer"
                        id="scheduler"
                        onClick={(e) => {
                            handleshowPopup(e);
                        }}
                    />
                </div>
                <hr className="m-0 p-0"></hr>
                <Tab.Container defaultActiveKey={viewOption.split(",")[0]} className="underlined-tabing">
                    <Nav variant="pills" className="flex workflow-config-tab">
                        {
                            viewOption.toUpperCase().indexOf("GENERAL") >= 0 &&
                            <Nav.Item>
                                <Nav.Link eventKey="General">General</Nav.Link>
                            </Nav.Item>
                        }
                        {
                            viewOption.toUpperCase().indexOf("PARAMETERS") >= 0 &&
                            <Nav.Item>
                                <Nav.Link eventKey="Parameters">Parameters</Nav.Link>
                            </Nav.Item>
                        }

                        {
                            viewOption.toUpperCase().indexOf("WEBHOOK") >= 0 &&
                            <Nav.Item>
                                <Nav.Link eventKey="Webhook">Webhook</Nav.Link>
                            </Nav.Item>
                        }


                    </Nav>
                    <Tab.Content>
                        {
                            viewOption.toUpperCase().indexOf("GENERAL") >= 0 &&
                            <Tab.Pane eventKey="General">
                                <div className="popup-body main-configbody">
                                    <h6>Workspace's</h6>
                                    <div className="ms-0 ps-0 p-2">
                                        <Row>
                                            <Col xl={12}>
                                                <Form.Group className="form-group mb-2">
                                                    <Form.Label className="login-label">
                                                        Workspace{" "}
                                                        <span className="ms-1 red-color-text">*</span>
                                                    </Form.Label>
                                                    <div
                                                        className={`position-relative ${workspaceInput?.length === 0 ? "error-border-line" : ""}`}
                                                    >
                                                        <CustomSelect
                                                            isMulti
                                                            isCreatable
                                                            placeholder="Start typing to add Workspace's.."
                                                            options={workspaceListOpt}
                                                            setOptions={setWorkspaceListOpt}
                                                            value={workspaceInput}
                                                            setValue={setWorkspaceInput}
                                                            isDisabled={isViewMode}
                                                        />
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {!configInput.eksnodegroup && infraAutomationList?.length > 0 && (
                                        <>
                                            <h6>Automation</h6>
                                            <div className="ms-0 ps-0 p-2">
                                                <Row>
                                                    <Col xl={12}>
                                                        <Form.Group className="form-group mb-2">
                                                            <Form.Label className="login-label">
                                                                Infrastructure Automation
                                                            </Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Select
                                                                    disabled={isViewMode}
                                                                    name="subscribersinfrastructureautomationid"
                                                                    value={configInput.subscribersinfrastructureautomationid || ""}
                                                                    onChange={(e) =>
                                                                        fnInputChange(e.target.value, "subscribersinfrastructureautomationid")
                                                                    }
                                                                    className="common-input"
                                                                >
                                                                    <option value="">Select Infrastructure Automation</option>
                                                                    {infraAutomationList.map((option) => (
                                                                        <option
                                                                            key={option.subscribersinfrastructureautomationid}
                                                                            value={option.subscribersinfrastructureautomationid}
                                                                        >
                                                                            {option.displayname || option.clientname}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </>
                                    )}

                                    {!configInput.subscribersinfrastructureautomationid && EksNodeList?.length > 0 && (
                                        <>
                                            <h6>Instances</h6>
                                            <div className="ms-0 ps-0 p-2">
                                                <Row>
                                                    <Col xl={12}>
                                                        <Form.Group className="form-group mb-2">
                                                            <Form.Label className="login-label">
                                                                Node
                                                            </Form.Label>
                                                            <div className="position-relative">
                                                                <Form.Select
                                                                    disabled={isViewMode}
                                                                    name="eks_node"
                                                                    value={configInput.eksnodegroup}
                                                                    onChange={(e) =>
                                                                        fnInputChange(e.target.value, "eksnodegroup")
                                                                    }
                                                                    className="common-input"
                                                                >
                                                                    <option value="">Select EKS Node</option>
                                                                    {EksNodeList.map((option) => (
                                                                        <option key={option.key} value={option.value}>
                                                                            {option.key}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </div>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </>
                                    )}

                                    <h6>Machine</h6>
                                    <div className="ms-0 ps-0 p-2">
                                        <Row>
                                            <Col xl={12}>
                                                <Form.Group className="form-group mb-2">
                                                    <Form.Label className="login-label">
                                                        Retry Limit
                                                    </Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            disabled={isViewMode}
                                                            type="text"
                                                            maxLength={100}
                                                            placeholder="Retry limit"
                                                            className="common-input"
                                                            value={configInput.retrystrategy}
                                                            onChange={(e) =>
                                                                fnInputChange(e.target.value, "retrystrategy")
                                                            }
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <span className="condigdata-span">
                                                            Number of retries of failures machines{" "}
                                                            <b>(In Number Of Time)</b>
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                            <Col xl={12}>
                                                <Form.Group className="form-group mb-2">
                                                    <Form.Label className="login-label">
                                                        Parallelism Limit
                                                    </Form.Label>
                                                    <div className="position-relative">
                                                        <Form.Control
                                                            disabled={isViewMode}
                                                            type="text"
                                                            maxLength={100}
                                                            placeholder="Parallelism Limit"
                                                            className="common-input"
                                                            value={configInput.parallelism}
                                                            onChange={(e) =>
                                                                fnInputChange(e.target.value, "parallelism")
                                                            }
                                                            onKeyPress={(event) => {
                                                                if (!/[0-9]/.test(event.key)) {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                        <span className="condigdata-span">
                                                            Number of run parallelism of machines{" "}
                                                            <b>(In Number Of Time)</b>
                                                        </span>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                                <div className="popup-footer">
                                    <button className="grey-btn" onClick={handleshowPopup}>
                                        Cancel
                                    </button>
                                    <button
                                        disabled={isViewMode}
                                        className={isViewMode ? "disable-blue-btn" : "blue-btn"}
                                        onClick={async (e) => {
                                            handleSaveConfig(e);
                                        }}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </Tab.Pane>
                        }
                        {
                            viewOption.toUpperCase().indexOf("PARAMETERS") >= 0 &&
                            <Tab.Pane eventKey="Parameters">
                                <div className="popup-body main-configbody ">
                                    <h6>Parameters For Workflow</h6>
                                    <div className="ms-0 ps-0 p-2">
                                        {configInput &&
                                            configInput.parametersforworkflow &&
                                            configInput.parametersforworkflow.map((para, paraindex) => {
                                                const controlConfig = getInputControlByType(para.inputType || "Text Box");
                                                return (
                                                    <>
                                                        <div className="weebhook-url-add-box">
                                                            <div className="position-relative webhookaddicon-inner">
                                                                <Row className="g-2">
                                                                    <Col md={6}>
                                                                        <Form.Control
                                                                            type="text"
                                                                            id={"txtparakey" + (paraindex + 1)}
                                                                            placeholder="Enter key name (letters, numbers, _)"
                                                                            className="common-input"
                                                                            value={para.name}
                                                                            onChange={(e) =>
                                                                                fnChangeParaName(e.target.value, paraindex)
                                                                            }
                                                                            isInvalid={para.isvalidName}
                                                                        />
                                                                        {para.isvalidName && (
                                                                            <Form.Control.Feedback type="invalid" className="d-block">
                                                                                <span className="error-message-icon">
                                                                                    <img
                                                                                        src={infoIcon}
                                                                                        alt="infoIcon"
                                                                                        title={para.isvalidName}
                                                                                    />
                                                                                </span>
                                                                            </Form.Control.Feedback>
                                                                        )}
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <Form.Select
                                                                            id={"ddlparainputtype" + (paraindex + 1)}
                                                                            className="common-input"
                                                                            value={para.inputType || "Text Box"}
                                                                            onChange={(e) =>
                                                                                fnChangeParaInputType(e.target.value, paraindex)
                                                                            }
                                                                            isInvalid={para.isvalidType}
                                                                        >
                                                                            {inputTypeOptions.map((option) => (
                                                                                <option key={option.value} value={option.value}>
                                                                                    {option.label}
                                                                                </option>
                                                                            ))}
                                                                        </Form.Select>
                                                                        {para.isvalidType && (
                                                                            <Form.Control.Feedback type="invalid" className="d-block">
                                                                                <span className="error-message-icon">
                                                                                    <img
                                                                                        src={infoIcon}
                                                                                        alt="infoIcon"
                                                                                        title={para.isvalidType}
                                                                                    />
                                                                                </span>
                                                                            </Form.Control.Feedback>
                                                                        )}
                                                                    </Col>
                                                                </Row>

                                                                <Form.Control
                                                                    as={controlConfig.as}
                                                                    rows={controlConfig.rows}
                                                                    id={"txtparavalue" + (paraindex + 1)}
                                                                    type={controlConfig.type}
                                                                    step={controlConfig.step}
                                                                    placeholder={controlConfig.placeholder}
                                                                    className="common-input mt-2"
                                                                    value={para.value}
                                                                    onChange={(e) =>
                                                                        fnChangeParaValue(e.target.value, paraindex)
                                                                    }
                                                                    isInvalid={para.isvalid}
                                                                />
                                                                {para.isvalid && (
                                                                    <Form.Control.Feedback type="invalid" className="d-block">
                                                                        <span className="error-message-icon">
                                                                            <img
                                                                                src={infoIcon}
                                                                                alt="infoIcon"
                                                                                title={para.isvalid}
                                                                            />
                                                                        </span>
                                                                    </Form.Control.Feedback>
                                                                )}
                                                            </div>
                                                            <div className="addicon-setdata">
                                                                {configInput.parametersforworkflow.length ===
                                                                    paraindex + 1 ? (
                                                                    <>
                                                                        <img
                                                                            className={"action"}
                                                                            src={addicon}
                                                                            alt=""
                                                                            id={"btnadd" + (paraindex + 1)}
                                                                            onClick={(e) => fnAddPara()}
                                                                        />
                                                                        <img
                                                                            className={"action"}
                                                                            src={removeicon}
                                                                            alt=""
                                                                            id={"btndelete" + (paraindex + 1)}
                                                                            onClick={(e) => fnRemovePara(paraindex)}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <img
                                                                        className={"action"}
                                                                        src={removeicon}
                                                                        alt=""
                                                                        id={"btndelete" + (paraindex + 1)}
                                                                        onClick={(e) => fnRemovePara(paraindex)}
                                                                    />
                                                                )}
                                                            </div>

                                                        </div>
                                                        <hr />
                                                    </>
                                                );
                                            })}
                                    </div>
                                </div>
                                <div className="popup-footer">
                                    <button className="grey-btn" onClick={handleshowPopup}>
                                        Cancel
                                    </button>
                                    <button
                                        disabled={isViewMode}
                                        className={isViewMode ? "disable-blue-btn" : "blue-btn"}
                                        onClick={async (e) => {
                                            handleSavePara(e);
                                        }}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </Tab.Pane>
                            
                        }
                        {
                            viewOption.toUpperCase().indexOf("WEBHOOK") >= 0 &&
                            <Tab.Pane eventKey="Webhook">
                                <div className="popup-body main-configbody-webhook">
                                    <WebhookCommon
                                        hooktype="trigger-run-workflow"
                                        associationid={associationid}
                                        associationtype="Workflow"
                                        isViewMode={isViewMode}
                                    />
                                </div>
                            </Tab.Pane>
                        }
                    </Tab.Content>
                </Tab.Container>
            </div>
        </>
    );
}

export default ConfigModel;
